<script>
import axios from 'axios'

const redirectorUrl = `https://samcloud.spacial.com/api/listen?sid=90544&rid=164144&f=aac,any&br=64000,any&m=sc`
const getStreamUrlPeriod = 10 * 60000 // 10 minutes

export default {
  name: 'RadioPlayer',
  data () {
    return {
      player: null,
      isPlaying: false,
      currentStreamUrl: redirectorUrl
    }
  },
  created () {
    this.player = document.createElement('audio')
    this.player.controls = 'controls'
    this.player.type = 'audio/aacp'
    this.loadCurrentStreamUrl()
  },
  methods: {
    play () {
      if (this.player.src !== this.currentStreamUrl) {
        this.player.src = this.currentStreamUrl
      }
      this.player.play()
      this.isPlaying = true
      this.$emit('EventMusicStatusChanged', true)
    },
    pause () {
      this.player.pause()
      this.isPlaying = false
      this.$emit('EventMusicStatusChanged', false)
    },
    getIsPlaying () {
      return this.isPlaying
    },
    /**
     * Prepares url aquired from backend
     * @param {string} url
     * @returns {bool}
     */
    prepareStreamUrl (url) {
      url = url.replace('http:', 'https:')
      let newUrl
      if (url) {
        newUrl = url
      } else {
        newUrl = redirectorUrl
      }
      this.currentStreamUrl = newUrl
    },
    /**
     * Get stream url
     * @returns {AxiosPromise<any>}
     */
    loadCurrentStreamUrl () {
      let vm = this
      axios.get(`/get-current-stream`)
        .then(response => {
          vm.prepareStreamUrl(response.data)
          setTimeout(function () {
            vm.loadCurrentStreamUrl()
          }, getStreamUrlPeriod)
        })
        .catch(() => {
          vm.currentStreamUrl = redirectorUrl
          setTimeout(function () {
            vm.loadCurrentStreamUrl()
          }, getStreamUrlPeriod)
        })
    },

    /**
     * Function to get current platform
     * @returns {*}
     */
    getOS () {
      let userAgent = window.navigator.userAgent
      let platform = window.navigator.platform
      let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
      let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
      let iosPlatforms = ['iPhone', 'iPad', 'iPod']
      let os = null

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }

      return os
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Player/RadioPlayer.vue